export const LaborContractVi = {
    "employeeContractConfig": {
        "header": "Cài đặt mã hợp đồng",
        "detail": {
            "applyWorkflow": "Khi bật cài đặt này, hợp đồng sẽ được áp dụng tính năng duyệt. Chỉ khi hợp đồng được duyệt thì mọi thông tin về công việc, lương, phụ cấp, phép... mới được cập nhật"
        },
        "title": {
            "settingPatternCode": "Cài đặt mã hợp đồng",
            "applyWorkflow": "Áp dụng quy trình duyệt vào hợp đồng",
            "laborContractType": "Loại hợp đồng lao động",
            "allowancesType": "Cài đặt loại phụ cấp"
        },
        "btn": {
            "setting": "Cài đặt"
        },
        "message": {
            "add": "Cập nhật thành công",
            "failed": "Cập nhật thất bại"
        }
    }
}